import { useRef, useEffect } from 'react';
import messages from '../intl/index.js';
import dropdownStyles from './Dropdown.module.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMessageFormatter } from '../../i18n/format.js';
import { UNSAFE_Icon } from '../../icon/Icon.js';
import classNames from 'clsx';
import { MdCheckBox, MdCheckBoxOutlineBlank } from '../../node_modules/react-icons/md/index.js';

const selectAllValue = Symbol('dsx-select-all');
function SelectAllItem(props) {
  const {
    activeValue,
    id,
    label,
    selected,
    onSelect
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages);
  const active = activeValue === selectAllValue;
  const className = classNames(dropdownStyles['option'], dropdownStyles['multi-option-contents'], active && dropdownStyles['active'], selected && dropdownStyles['selected']);
  const checkIcon = selected ? MdCheckBox : MdCheckBoxOutlineBlank;
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      ref.current?.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  return /*#__PURE__*/jsxs("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    onClick: onSelect,
    children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: checkIcon,
      size: "size-400"
    }), label || formatMessage('Select all')]
  });
}

export { SelectAllItem, selectAllValue };
